// cost/useOvershootMap.ts
import { useContext, useMemo } from 'react';
import { CouncilContext } from '../../../../contexts/CouncilContext';
import { buildOvershootByTurn } from '../../../../services/councilCost';
import type { OvershootEvent } from '../../../../types/council';

const EMPTY_MAP: Map<string, OvershootEvent> = new Map();

export function useOvershootMap(): Map<string, OvershootEvent> {
  const ctx = useContext(CouncilContext);
  const events = ctx?.state?.cost?.overshoot_events;
  return useMemo(() => (events && events.length ? buildOvershootByTurn(events) : EMPTY_MAP), [events]);
}
